import { z } from "zod";

export const Point2D = z.object({
  x: z.number(),
  y: z.number(),
});

export type Point2D = z.infer<typeof Point2D>;
